/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Consession': {
    width: 33,
    height: 21,
    viewBox: '0 0 33 21',
    data: '<path pid="0" d="M29.88 0H2.194A2.19 2.19 0 000 2.195v15.868c0 1.216.979 2.228 2.195 2.228h27.684c1.216 0 2.195-.978 2.195-2.228V2.229C32.074.98 31.095 0 29.879 0zM13.571 15.497c-.372.507-.946.81-1.587.81H6.111a1.95 1.95 0 01-1.586-.81 2.026 2.026 0 01-.303-1.755l.472-1.485c.337-1.114 1.114-1.991 2.06-2.566A3.263 3.263 0 015.74 7.293a3.35 3.35 0 013.342-3.342 3.35 3.35 0 013.342 3.342c0 .946-.405 1.79-1.013 2.398.945.573 1.722 1.452 2.06 2.566l.472 1.485c.134.607 0 1.249-.372 1.755zm13.505-1.755h-9.96a.764.764 0 01-.777-.777c0-.439.338-.777.777-.777h9.96c.439 0 .776.338.776.777 0 .44-.372.777-.776.777zm0-5.64h-9.96a.764.764 0 01-.777-.776c0-.44.338-.777.777-.777h9.96c.439 0 .776.338.776.777 0 .406-.372.777-.776.777z" _fill="#3D4B55"/>'
  }
})
